<template>
  <v-data-table
    :headers="headers"
    sort-asc-icon="$chevron-down"
    sort-desc-icon="$chevron-up"
    :items="items"
    fixed-header
    class="engagement-dialog-table"
    :page="page"
    must-sort
    :sort-by="[{ key: sortBy, order: sortDesc ? 'desc' : 'asc' }]"
    @update:sort-by="$emit('sortChange', $event)"
  >
    <template #[`item.name`]="{ item }">
      <span class="engagement-name modal-name">{{ item.name }}</span>
    </template>
    <template #[`item.avgScore`]="{ item }">
      <span
        class="engagement-score"
        :style="{ color: item.color }"
      >{{ item.avgScore }}</span>
    </template>
    <template #[`item.totalRevisions`]="{ item }">
      <span class="engagement-total-revisions">{{ item.totalRevisions }}</span>
    </template>
    <template #[`item.postsEdited`]="{ item }">
      <span class="engagement-posts-edited">{{ item.postsEdited }}</span>
    </template>
    <template #bottom>
      <span />
    </template>
  </v-data-table>
</template>

<script>
export default {
  name: 'EngagementUsersTable',
  props: {
    headers: {
      type: Array,
      required: true,
    },
    items: {
      type: Array,
      required: true,
    },
    page: {
      type: Number,
      default: 1,
    },
    sortBy: {
      type: String,
      default: '',
    },
    sortDesc: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['sortChange'],
};
</script>

<style lang="less" scoped>
  span.engagement-name {
    font-weight: 500;
    font-size: 16px;
    line-height: 20px;
    width: auto;
    flex: 1;
    text-align: left;

    &.modal-name {
      font-size: 16px;
    }
  }

  span.engagement-score {
    font-weight: 500;
    text-align: right;
    flex: 0 auto;
  }

  span.engagement-total-revisions {
    color: @text-brand;
    font-weight: 500;
    text-align: right;
    flex: 0 auto;
  }

  span.engagement-posts-edited {
    color: @text-brand;
    font-weight: 500;
    text-align: right;
    flex: 0 auto;
  }

  .engagement-dialog-table {
    max-height: 100%;
    width: 100%;
  }
</style>
